export default __webpack_public_path__ + "static/media/Sanofi-Genzyme.6dce3084.png";